<atx-empty-placeholder
  class="empty-placeholder"
  [icon]="['fas', 'square-sliders-vertical']"
>
  <ng-container
    msg
    i18n="pbasketFilters|No filters ToShow@@noFiltersToShowErrorTitle"
  >
    We’re getting errors. Try refreshing the page or try searching later.
  </ng-container>
  <ng-container
    title
    i18n="
      pbasketFilters|No filters because of error@@noFiltersToShowErrorMessage"
  >
    Something went wrong
  </ng-container>
  <button
    class="btn btn-primary"
    i18n="pbasketFilters|Refresh filters search@@refreshFiltersSearchButton"
    (click)="onRefresh($event)"
  >
    Refresh
  </button>
</atx-empty-placeholder>
